/**
 * Defines the event-specific keys for CMCD (Common Media Client Data) version 2.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_EVENT_KEYS = [
	'e',
] as const;
